import React, {useState} from "react";
import './SecondaryMarket.scoped.scss';
import {useErrorCallback, useToggle} from "../../../../../../hooks";
import {DataCollection} from "../../../../../../utils";
import {SellingOffer} from "../../../../../../api-client";
import ProjectsFilter, {Filter} from "../../../../../../components/pages/projects/filter/ProjectsFilter/ProjectsFilter";
import {defaultProjectsFilter} from "../../../../../../components/pages/projects/filter/ProjectsFilter/utils";
import ProjectsContextProvider, {ProjectsContextType} from "../ProjectsContext";
import {createOfferProvider} from "../../../../../../di";
import {Block, Pagination} from "../../../../../../components";
import {SecondaryMarketOffer} from "../../../../../../components/pages/projects";
import apiClientConfig from 'configs/app';

const SecondaryMarket = () => {
  const handleError = useErrorCallback();
  const [loading, setLoading] = useState(false);
  const [offers, setOffers] =
        useState<DataCollection<SellingOffer>>(new DataCollection());

  const [filterActive, toggleFilter] = useToggle();
  const [favoritesActive, toggleFavorites] = useToggle();

  const [filter, setFilter] = useState<Filter>(defaultProjectsFilter);
  const secondaryMarketEnabled = apiClientConfig.secondaryMarketEnabled;
  const value: ProjectsContextType = {
    filter,
    setFilter,
    filterActive,
    toggleFilter,
    favoritesActive,
    toggleFavorites
  };

  const loadData = async (page: number, perPage: number) => {
    setLoading(true);
    try {
      const provider = await createOfferProvider();
      const offers = await provider.getListSellingOffers(page, perPage, filter);
      const dataCollection = new DataCollection<SellingOffer>();
      dataCollection.setCollection(offers);
      setOffers(dataCollection);
    } catch (error: any) {
      await handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const projectsList = () => {
    return offers.items.map((offer: SellingOffer) => {
      return <SecondaryMarketOffer offer={offer} key={offer.uuid}/>;
    });
  };

  return (
    <div>
      {!secondaryMarketEnabled && <div>Раздел находится в разработке</div>}
      {secondaryMarketEnabled &&
      <Pagination
        onLoad={loadData}
        count={offers.count}
        totalCount={offers.totalCount}
        filterObject={filter}
        initialChangeFilter={(value: Partial<Filter>) => setFilter({...filter, ...value})}
      >
        <ProjectsContextProvider props={value}>
          <Block>
            <Block.Content>
              <Block.Header className="secondary-market-block-header" withPadding>
                {/*<ProjectsHeader/>*/}
              </Block.Header>
              <Block.Body className="secondary-market-block-body" withPadding={false}>
                <ProjectsFilter/>
                <Pagination.Content loading={loading}>
                  <Pagination.Header className="secondary-market-header">
                    <div className="secondary-market-header__item">
                      Проект
                    </div>
                    <div className="secondary-market-header__item">
                      Категория
                    </div>
                    <div className="secondary-market-header__item">
                      Сумма сбора
                    </div>
                    <div className="secondary-market-header__item">
                      Прогноз взыскания
                    </div>
                    <div className="secondary-market-header__item">
                      Срок
                    </div>
                    <div className="secondary-market-header__item">
                      Доходность простая
                    </div>
                    <div className="secondary-market-header__item">
                      Доходность годовая
                    </div>
                    <div className="secondary-market-header__item">
                      Собрано
                    </div>
                    <div className="secondary-market-header__item">
                      Сбор до
                    </div>
                    <div className="secondary-market-header__item">
                      Сумма участия
                    </div>
                    <div className="secondary-market-header__item">
                      Действия
                    </div>
                  </Pagination.Header>
                  <ul className="secondary-market__list">
                    {projectsList()}
                  </ul>
                </Pagination.Content>
              </Block.Body>
            </Block.Content>
          </Block>
          <Pagination.Paginator/>
        </ProjectsContextProvider>
      </Pagination>}
    </div>
  );
};

export default SecondaryMarket;